<template>
  <BaseModalSmall
    testId="recurring-options"
    @close="onCancelClick"
  >
    <Flex direction="column">
      <BaseText size="l">
        {{ $t(`global.actions.${data.action === 'update' ? 'edit' : data.action}_${data.type}`) }}
      </BaseText>
      <BaseRadio
        v-model="value"
        :options="options"
        v-test="'recurring-edit-options'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="onCancelClick"
        v-test="'recurring-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        @click="onSubmitClick"
        v-test="'recurring-submit'"
      >
        {{ $t('global.actions.submit') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import eventBus from '@/event-bus';

export default defineComponent({
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      value: 'single',
    };
  },
  computed: {
    options() {
      const options = [
        {
          label: this.$t(
            `calendar.recurrence_update_state_options.${this.data.type}.single`,
          ),
          value: 'single',
        },
        {
          label: this.$t(
            `calendar.recurrence_update_state_options.${this.data.type}.future`,
          ),
          value: 'future',
        },
      ];
      if (
        !this.data.disableRecurringOriginalOption &&
        (!this.data.rrule || this.data.rrule.freq === 'daily') &&
        this.data.type !== 'appointment'
      ) {
        options.push({
          label: this.$t(
            `calendar.recurrence_update_state_options.${this.data.type}.original`,
          ),
          value: 'original',
        });
      }
      return options;
    },
  },
  methods: {
    onCancelClick() {
      eventBus.$emit('submit-confirmation-modal', false);
    },
    onSubmitClick() {
      eventBus.$emit('submit-confirmation-modal', this.value);
    },
  },
});
</script>
